module.exports = __webpack_public_path__ + "static/media/David-Friend-Hall.fd858390.png";